import './modules/googleTag';
import './components/PageHeader';

import { Router } from '@af-modules/router';
import Application from 'application-frame/core/Application';
import AppDrawer from './modules/AppDrawer';
import MainPage from './pages/MainPage';
import ImprintPage from './pages/ImprintPage';

Router.init([{
    path: '/',
    onEnter() {
        location.hash = '#!/home';
    }
}, {
    path: '/blog',
    onEnter() {
        location.replace('http://blog.titannano.de');
    }
}]);


const App = {

    init() {
        Router.addRoutable(MainPage.route, MainPage);
        Router.addRoutable(ImprintPage.route, ImprintPage);

        AppDrawer.constructor();
        Router.restore();
    },

    __proto__: Application,
};

App.init();

if (window.WebComponents && window.WebComponents.ready) {
    document.body.removeAttribute('unresolved');
} else {
    window.addEventListener('WebComponentsReady', () => document.body.removeAttribute('unresolved'));
}



export default App;



//////////////////
// WEBPACK FOOTER
// ./main.js
// module id = 25
// module chunks = 0